import { render } from "./AppList.vue?vue&type=template&id=2381997c&scoped=true"
import script from "./AppList.vue?vue&type=script&lang=js"
export * from "./AppList.vue?vue&type=script&lang=js"

import "./AppList.vue?vue&type=style&index=0&id=2381997c&scoped=true&lang=css"

import exportComponent from "/var/lib/docker/jenkins_home/workspace/spider-web-gp-tools-s3-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2381997c"]])

export default __exports__